import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'ceres-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LayoutComponent implements OnInit, OnDestroy {
    private readonly doc = inject<Document>(DOCUMENT);

    @Input()
    background: undefined | 'white' | 'gray' | 'grey';

    ngOnInit(): void {
        this.doc.body.classList.add('new-wrapper');
    }

    ngOnDestroy(): void {
        this.doc.body.classList.remove('new-wrapper');
    }
}
